import React from 'react'
import Header from '../reusables/Header'

const ViewsLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className='imm_consultant__views_layout'>
      <Header />
      <div className='views_cont'>
        <div className='views_pages'>
          {children}
        </div>
      </div>
    </div>
  );
};

export default ViewsLayout;